import React from "react";
import styles from "./style.module.scss";
import { useTranslation } from "react-i18next";

const LegalInfo = () => {
  const { t } = useTranslation();

  const legalDocuments = [
    {
      title: t("legalInfo.publicOffer"),
      href: "/offer-agreement.pdf",
    },
    {
      title: t("legalInfo.refundPolicy"),
      href: "/privacy-policy-payments.pdf",
    },
    {
      title: t("legalInfo.privacyPolicy"),
      href: "/privacy-policy.pdf",
    },
  ];

  return (
    <div className={styles["legal"]}>
      <div className={styles["legal-title"]}>{t("legalInfo.title")}</div>
      <hr className={styles["legal-hr"]}></hr>
      <div className={styles["legal-list"]}>
        {legalDocuments.map((doc, index) => (
          <a
            key={index}
            className={styles["legal-link"]}
            href={doc.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {doc.title}
          </a>
        ))}
      </div>
    </div>
  );
};

export default LegalInfo;
